import FornecedoresRotas from './fornecedor/FornecedorRotas'
import FinanceiroRotas from './financeiro/FinanceiroRotas'
import UaiRotas from './uai/UaiRotas'
import UcicRotas from './ucic/UcicRotas'

export default {
    path: 'pleitos',
    name: 'Pleitos',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [FornecedoresRotas, FinanceiroRotas, UaiRotas, UcicRotas]
}
